// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const golett: PokeData = {
  "id": 622,
  "name": "golett",
  "height": 10,
  "weight": 920,
  "base_experience": 61,
  "types": [
    PokeType.GROUND,
    PokeType.GHOST
  ],
  "api_moves": [
    "pound",
    "mega-punch",
    "earthquake",
    "night-shade",
    "defense-curl",
    "curse",
    "mud-slap",
    "rollout",
    "magnitude",
    "dynamic-punch",
    "shadow-ball",
    "focus-punch",
    "astonish",
    "shadow-punch",
    "iron-defense",
    "hammer-arm",
    "heavy-slam",
    "phantom-force",
    "stomping-tantrum"
  ],
  "moves": [
    "earthquake",
    "night-shade",
    "curse",
    "mud-slap",
    "magnitude",
    "shadow-ball",
    "iron-defense",
    "phantom-force",
    "spectral-chain",
    "earth-power",
    "shadow-sneak",
    "shadow-claws",
    "bonemerang"
  ],
  "evolution_chain": {
    "id": 316,
    "item": null,
    "species": [
      {
        "name": "golett",
        "order": 623,
        "types": [
          PokeType.GROUND,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golurk",
        "order": 624,
        "types": [
          PokeType.GROUND,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 622,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 43,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 54.5,
    "speed": 35,
    "ability_power": 74
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
